import React, { ReactNode, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import "swiper/css";
import styled from "styled-components";
import { Navigation } from "swiper/modules";
import {useViewPortState} from "../../provider/ResizeProvider";

SwiperCore.use([Navigation]);

interface SliderProps {
    children: ReactNode[];
    setLbIndex: (p: number) => void;
}

const StyledSwiper = styled(Swiper)`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const Slider: React.FC<SliderProps> = ({ children, setLbIndex }) => {
    const {isDesktopState} = useViewPortState()
    const [swiper, setSwiper] = useState<SwiperCore | null>(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleSlideChange = (swiper: SwiperCore) => {
        setCurrentIndex(swiper.realIndex);
        setLbIndex(swiper.realIndex);
    };

    return (
        <StyledSwiper
            onSwiper={setSwiper}
            onSlideChange={handleSlideChange}
            spaceBetween={isDesktopState ? 16 : 10}
            slidesPerView={isDesktopState ? 1.1 : 1.2}
        >
            {children.map((child, index) => (
                <SwiperSlide key={index}>
                    {child}
                </SwiperSlide>
            ))}
        </StyledSwiper>
    );
};
